// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const MessageDeleteTooQuickModal = observer(() => {
	const {t} = useLingui();
	return (
		<ConfirmModal
			title={t`You're deleting messages too quickly`}
			description={t`The problem with being faster than light is that you can only live in darkness. Take a breather and try again.`}
			primaryText={t`Gotcha`}
			onPrimary={() => {}}
			secondaryText={false}
			hideCloseButton
		/>
	);
});
